import { render } from "./TaskCard.vue?vue&type=template&id=7d37d1b6&scoped=true&ts=true"
import script from "./taskCardHelper.ts?vue&type=script&lang=ts"
export * from "./taskCardHelper.ts?vue&type=script&lang=ts"

import "./TaskCard.vue?vue&type=style&index=0&id=7d37d1b6&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d37d1b6"]])

export default __exports__